import { render, staticRenderFns } from "./ListVideos.vue?vue&type=template&id=4c7deb6e&"
import script from "./ListVideos.vue?vue&type=script&lang=js&"
export * from "./ListVideos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports